import { toast } from "react-toastify";
import { Organization } from "../../domain/organization/organization";
import { BaseApplicationService } from "../../domain/base/base-application-service";
import { reportUnexpectedError } from "../../../error-reporter";
import { gqlClient, gqlHeader, runGqlQueryV2 } from "../../../graphql/client";
import apiClient from "../../apis/api-client";

export type OrgGBizIDSettingContextProps = {
  isLoading: boolean;
  organization?: Organization;
  fetchOrganization: typeof OrgGBizIDSettingService.prototype.fetchOrganization;
  updateOrgGBizIDSetting: typeof OrgGBizIDSettingService.prototype.updateOrgGBizIDSetting;
};

export class OrgGBizIDSettingService extends BaseApplicationService<OrgGBizIDSettingContextProps> {
  state = {
    isLoading: false,
    fetchOrganization: this.fetchOrganization.bind(this),
    updateOrgGBizIDSetting: this.updateOrgGBizIDSetting.bind(this),
  };

  async fetchOrganization(orgId: string) {
    this.setIsLoading(true);
    try {
      const { data: organization } = await apiClient.getOrganization(orgId);
      this.setState({ organization });
    } catch (e) {
      if (e.response.data.code === "not_found") {
        return;
      }
      reportUnexpectedError(e);
      toast.error("テナントの取得に失敗しました。");
    } finally {
      this.setIsLoading(false);
    }
  }

  async updateOrgGBizIDSetting(
    orgId: string,
    activated: boolean,
    clientId?: string,
    clientSecret?: string,
  ): Promise<void> {
    const res = await runGqlQueryV2(() =>
      gqlClient.UpdateOrgGBizIDSetting(
        { orgId, activated, clientId, clientSecret },
        gqlHeader("m"),
      ),
    );
    if (res.error) {
      reportUnexpectedError(res.error.rawError);
      toast.error("GビズID設定の更新に失敗しました");
      return;
    }
    toast.success("GビズID設定を更新しました");
  }

  private setIsLoading(isLoading: boolean) {
    this.setState({
      isLoading: isLoading,
    });
  }
}
